export enum IdentityProviders {
  GOOGLE = 'Google',
  APPLE = 'Apple',
}

type SocialProviderRecord = {
  googleId?: string;
  appleId?: string;
  expiresAt: number;
  provider: IdentityProviders;
};

class SocialProviderStore {
  private storageItemKey = 'socialProvider';

  private tenMinutesTTL = 10 * 60 * 1000;

  setSocialProvider = (socialProviderRecord: Partial<SocialProviderRecord>) => {
    const currentData = this.getSocialProviderData();
    sessionStorage.setItem(
      this.storageItemKey,
      JSON.stringify({
        ...currentData,
        ...socialProviderRecord,
        expiresAt: new Date().getTime() + this.tenMinutesTTL,
      })
    );

    setTimeout(() => {
      this.clearSocialProvider();
    }, this.tenMinutesTTL);
  };

  getSocialProviderData = (): SocialProviderRecord | null => {
    const data = sessionStorage.getItem(this.storageItemKey);
    if (!data) {
      return null;
    }

    const parsedData: SocialProviderRecord = JSON.parse(data);
    if (parsedData.expiresAt < new Date().getTime()) {
      this.clearSocialProvider();
      return null;
    }
    return parsedData;
  };

  clearSocialProvider = (): void => {
    sessionStorage.removeItem(this.storageItemKey);
  };

  getLoginType = () => {
    const socialProvider = this.getSocialProviderData()?.provider;
    if (IdentityProviders.APPLE === socialProvider) return 'apple';
    if (IdentityProviders.GOOGLE === socialProvider) return 'google';
    return 'email';
  };
}

export default new SocialProviderStore();
